import React, { useState, useEffect } from "react";
import { Title } from "../../Home/styles";
import { RotatingText } from "./styles";

const phrases = [
  "No matter where,",
  "No importa dónde,",
  "Onde quer que seja,",
  "Peu importe onde,",
  "Non importa dove,",
];

const subphrases = [
  "we get there!",
  "llegaremos allá!",
  "a gente chega lá!",
  "nós chegaremos lá!",
  "ci arriviamo!",
];

const INTERVAL = 3500; // tempo que cada frase fica visível (ms)
const TRANSITION = 400; // precisa bater com a duração da animação acima

export const RotatingTitle = ({ StarComponent }) => {
  const [index, setIndex] = useState(0);
  const [fading, setFading] = useState(false);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;

    const timer = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % phrases.length);
        setFading(false);
      }, TRANSITION);
    }, INTERVAL);

    return () => clearInterval(timer);
  }, [paused]);

  return (
    <Title
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-live="polite"
    >
      <RotatingText $fading={fading}>
        {phrases[index]}
        <br />
        {subphrases[index]}
      </RotatingText>
      {StarComponent}
    </Title>
  );
};